export default __webpack_public_path__ + "static/media/status_offline.d6d98e4c.svg";